import React from "react";

const DateDisplay = ({ date }) => {
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);

        const mois = [
            'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
            'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
        ];

        const jour = date.getDate().toString().padStart(2, '0');
        const moisNom = mois[date.getMonth()];
        const annee = date.getFullYear();

        return `${jour} ${moisNom} ${annee}`;
    };

    return <>{formatDate(date)}</>;
};

export default DateDisplay;
